import { ArrowLeftIcon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";
import { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDirty } from "../contexts/DirtyContext";
import { ConfirmDirtyNavigationDialog } from "../components/modals/ConfirmDirtyNavigationDialog";

interface BackButtonProps {
  levels?: number;
}

export function BackButton({ levels = 1 }: BackButtonProps) {
  if (levels < 1) {
    throw new Error("levels must be at least 1");
  }

  const [dirty] = useDirty();
  const [confirmDirtyNav, setConfirmDirtyNav] = useState(false);

  const navigate = useNavigate();

  const to = useMemo(() => new Array(levels).fill("..").join("/"), [levels]);

  return (
    <>
      <ConfirmDirtyNavigationDialog
        isOpen={confirmDirtyNav}
        onConfirm={(confirmed) => {
          if (confirmed) navigate(to);
          setConfirmDirtyNav(false);
        }}
      />
      <Button
        as={Link}
        iconSpacing={1}
        leftIcon={<ArrowLeftIcon h={3} verticalAlign="baseline" />}
        onClick={(event) => {
          if (!dirty) return;

          setConfirmDirtyNav(true);
          event.preventDefault();
          event.stopPropagation();
        }}
        to={to}
      >
        Ga terug
      </Button>
    </>
  );
}
